import { render } from "./Location.vue?vue&type=template&id=67036e0c&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"

import "./Location.vue?vue&type=style&index=0&id=67036e0c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-67036e0c"

export default script